export default "__VITE_ASSET__DvnXuf3v__"